import { render } from "./ProjectCommentOffcanvas.vue?vue&type=template&id=6887053a&scoped=true&ts=true"
import script from "./ProjectCommentOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProjectCommentOffcanvas.ts?vue&type=script&lang=ts"

import "./ProjectCommentOffcanvas.scss?vue&type=style&index=0&id=6887053a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6887053a"]])

export default __exports__